import { useUnitName } from "../UnitNames";
import { Dropdown } from "@akin2unde/flowui-react";
import type { KeyValue } from "../../models/KeyValue";
import type { Product } from "../../models/Product";
import type { ProductUnit } from "../../models/Unit";
import { activeProductUnits } from "../../utils/ProductUnits";
export const lookupProduct = (products: KeyValue[], code: string) => products.find(x => x.Key === code)?.Other as Product | undefined;
export function ProductUnitPicker({ product, value, factor, onChange }: {
    product?: Product;
    value?: string;
    factor?: number;
    onChange: (unit: ProductUnit) => void;
}) {
    const unitName=useUnitName();
    const units = activeProductUnits(product);
    // PurchaseItem currently lacks persisted UnitCode: only infer when unambiguous.
    const matches = units.filter(x => x.BaseQuantity === factor);
    const selected = value || (matches.length === 1 ? matches[0].UnitCode : "");
    return <Dropdown searchable placeholder="Select product unit" value={selected} options={units.map(x => ({ display: `${unitName(x.UnitCode)} · ${x.BaseQuantity} base units`, value: x.UnitCode, other: x }))} onChange={option => { const unit = units.find(x => x.UnitCode === option.value); if (unit)
        onChange(unit); }}/>;
}
